module.exports = __webpack_public_path__ + "img/register-side.e9327806.svg";